<template>
  <el-dialog
    :model-value="modelValue"
    :title="dialogTitle"
    width="calc(100vw - 32px)"
    destroy-on-close
    class="assign-customer-dialog"
    @update:model-value="$emit('update:modelValue', $event)"
    @close="handleClose"
  >
    <div class="assign-dialog-body">
      <!-- 视图切换：当前已分配 / 去分配 -->
      <div class="mode-cards">
        <div
          class="mode-card"
          :class="{ 'is-active': mode === 'current' }"
          @click="setMode('current')"
        >
          <div class="mode-card__icon mode-card__icon--list">
            <el-icon :size="28">
              <List />
            </el-icon>
          </div>
          <div class="mode-card__text">
            <span class="mode-card__title">当前已分配客户</span>
            <span class="mode-card__desc">查看该业务员名下已分配的客户，可移除分配</span>
          </div>
        </div>
        <div
          class="mode-card mode-card--assign"
          :class="{ 'is-active': mode === 'assign' }"
          @click="setMode('assign')"
        >
          <div class="mode-card__icon mode-card__icon--assign">
            <el-icon :size="28">
              <Plus />
            </el-icon>
          </div>
          <div class="mode-card__text">
            <span class="mode-card__title">去分配用户</span>
            <span class="mode-card__desc">选择客户并分配给当前业务员</span>
          </div>
        </div>
      </div>

      <!-- 客户类型 -->
      <div class="section section-type">
        <div class="section-label">
          客户类型
        </div>
        <div class="user-type-segment-wrap">
          <div
            class="user-type-segment"
            role="tablist"
            aria-label="客户类型"
          >
            <button
              type="button"
              role="tab"
              class="segment-item"
              :class="{ active: clientSearchForm.queryType === 'personal' }"
              :aria-selected="clientSearchForm.queryType === 'personal'"
              @click="setClientType('personal')"
            >
              个人客户
            </button>
            <button
              type="button"
              role="tab"
              class="segment-item"
              :class="{ active: clientSearchForm.queryType === 'enterprise' }"
              :aria-selected="clientSearchForm.queryType === 'enterprise'"
              @click="setClientType('enterprise')"
            >
              企业客户
            </button>
          </div>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="table-wrap">
        <el-table
          v-if="mode === 'current'"
          ref="currentTableRef"
          v-loading="clientLoading"
          :data="clientList"
          stripe
          border
          max-height="500"
          class="assign-table"
        >
          <template #empty>
            <EmptyPlaceholder
              v-if="!clientLoading"
              :description="emptyText"
            />
          </template>
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'personal'"
            prop="userRealName"
            label="真实姓名"
            min-width="90"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'personal'"
            prop="userNickName"
            label="昵称"
            min-width="90"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'personal'"
            prop="userIdCardNo"
            label="证件号"
            min-width="160"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'enterprise'"
            prop="entName"
            label="企业名称"
            min-width="140"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'enterprise'"
            prop="creditCode"
            label="主体识别码"
            min-width="160"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'enterprise'"
            prop="linkmanName"
            label="联系人"
            min-width="90"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'personal'"
            prop="userPhone"
            label="手机号"
            width="120"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'enterprise'"
            prop="linkmanPhone"
            label="联系人电话"
            width="120"
            align="center"
          />
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
          >
            <template #default="{ row }">
              <el-button
                type="danger"
                plain
                size="small"
                :loading="unassignLoadingMap[row.id]"
                @click="handleUnassign(row)"
              >
                移除分配
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-table
          v-else
          ref="assignTableRef"
          v-loading="clientLoading"
          :data="clientList"
          stripe
          border
          max-height="500"
          class="assign-table"
          @selection-change="handleClientSelectionChange"
        >
          <template #empty>
            <EmptyPlaceholder
              v-if="!clientLoading"
              :description="emptyText"
            />
          </template>
          <el-table-column
            type="selection"
            width="52"
            align="center"
          />
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'personal'"
            prop="userRealName"
            label="真实姓名"
            min-width="90"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'personal'"
            prop="userNickName"
            label="昵称"
            min-width="90"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'personal'"
            prop="userIdCardNo"
            label="证件号"
            min-width="160"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'enterprise'"
            prop="entName"
            label="企业名称"
            min-width="140"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'enterprise'"
            prop="creditCode"
            label="主体识别码"
            min-width="160"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'enterprise'"
            prop="linkmanName"
            label="联系人"
            min-width="90"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'personal'"
            prop="userPhone"
            label="手机号"
            width="120"
            align="center"
          />
          <el-table-column
            v-if="clientSearchForm.queryType === 'enterprise'"
            prop="linkmanPhone"
            label="联系人电话"
            width="120"
            align="center"
          />
        </el-table>

        <div class="pagination-section">
          <el-pagination
            v-model:current-page="clientPagination.pageNum"
            v-model:page-size="clientPagination.pageSize"
            :total="clientPagination.total"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="loadClientList"
            @size-change="handleClientSizeChange"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <template v-if="mode === 'assign'">
          <el-button
            type="primary"
            :loading="assignSubmitting"
            :disabled="selectedRelationIds.length === 0"
            @click="handleConfirmAssign"
          >
            确定分配（已选 {{ selectedRelationIds.length }} 人）
          </el-button>
        </template>
        <el-button @click="handleClose">
          关闭
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus'
import { List, Plus } from '@element-plus/icons-vue'
import { getUserList, assignClientsToSalesman, unassignClientsFromSalesman } from '@/api/workbench'
import EmptyPlaceholder from '@/components/EmptyPlaceholder.vue'
import { showEnhancedConfirmDialog } from '@/utils/messageUtils'

export default {
  name: 'AssignCustomerDialog',
  components: { List, Plus, EmptyPlaceholder },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    /** 当前要分配客户的业务员 { userId, userRealName } */
    salesman: {
      type: Object,
      default: () => ({ userId: null, userRealName: '' })
    }
  },
  emits: ['update:modelValue', 'success'],
  data() {
    return {
      mode: 'current', // 'current' 当前业务员客户 | 'assign' 分配用户
      clientList: [],
      clientLoading: false,
      clientSearchForm: { queryType: 'personal' },
      clientPagination: { pageNum: 1, pageSize: 10, total: 0 },
      selectedRelationIds: [],
      assignSubmitting: false,
      unassignLoadingMap: {} // row.id -> loading
    }
  },
  computed: {
    dialogTitle() {
      const name = this.salesman?.userRealName || ''
      return name ? `分配客户 - ${name}` : '分配客户'
    },
    emptyText() {
      if (this.mode === 'current') return '暂无已分配客户'
      return '暂无可分配客户，请确认已有授权客户'
    }
  },
  watch: {
    modelValue(val) {
      if (val && this.salesman?.userId) {
        this.mode = 'current'
        this.clientSearchForm.queryType = 'personal'
        this.clientPagination.pageNum = 1
        this.clientPagination.pageSize = 10
        this.selectedRelationIds = []
        this.unassignLoadingMap = {}
        this.loadClientList()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:modelValue', false)
    },
    setMode(val) {
      if (this.mode === val) return
      this.mode = val
      this.handleModeChange()
    },
    setClientType(type) {
      if (this.clientSearchForm.queryType === type) return
      this.clientSearchForm.queryType = type
      this.handleClientTypeChange()
    },
    handleModeChange() {
      this.clientPagination.pageNum = 1
      this.selectedRelationIds = []
      this.loadClientList()
    },
    handleClientTypeChange() {
      this.clientPagination.pageNum = 1
      this.selectedRelationIds = []
      this.loadClientList()
    },
    async loadClientList() {
      this.clientLoading = true
      try {
        const params = {
          queryType: this.clientSearchForm.queryType,
          authStatus: '1',
          pageNum: this.clientPagination.pageNum,
          pageSize: this.clientPagination.pageSize
        }
        // 当前业务员客户：传业务员 id；分配用户：传 -1 表示可分配客户查询
        if (this.mode === 'current' && this.salesman?.userId) {
          params.salesmanId = this.salesman.userId
        } else if (this.mode === 'assign') {
          params.salesmanId = 0
        }
        const res = await getUserList(params)
        if (res && res.code === 200) {
          this.clientList = res.rows || []
          this.clientPagination.total = res.total || 0
        } else {
          this.clientList = []
          this.clientPagination.total = 0
        }
      } catch (e) {
        console.error('加载客户列表失败', e)
        ElMessage.error(e.message || '加载客户列表失败')
        this.clientList = []
        this.clientPagination.total = 0
      } finally {
        this.clientLoading = false
      }
    },
    handleClientSizeChange() {
      this.clientPagination.pageNum = 1
      this.loadClientList()
    },
    handleClientSelectionChange(selection) {
      this.selectedRelationIds = selection.map((row) => row.id)
    },
    /** 移除分配（当前业务员客户列表中单条取消） */
    async handleUnassign(row) {
      const confirmed = await showEnhancedConfirmDialog(
        '确定取消该客户与当前业务员的分配关系吗？',
        '提示',
        '确定',
        '取消',
        { type: 'warning' }
      )
      if (!confirmed) return
      this.unassignLoadingMap = { ...this.unassignLoadingMap, [row.id]: true }
      try {
        const res = await unassignClientsFromSalesman([row.id])
        if (res && res.code === 200) {
          ElMessage.success('已移除分配')
          this.$emit('success')
          await this.loadClientList()
        } else {
          ElMessage.error(res?.msg || '移除分配失败')
        }
      } catch (e) {
        console.error('移除分配失败', e)
        ElMessage.error(e.message || '移除分配失败')
      } finally {
        this.unassignLoadingMap = { ...this.unassignLoadingMap, [row.id]: false }
      }
    },
    async handleConfirmAssign() {
      if (this.selectedRelationIds.length === 0) {
        ElMessage.warning('请至少选择一名客户')
        return
      }
      if (!this.salesman?.userId) {
        ElMessage.warning('业务员信息不完整')
        return
      }
      this.assignSubmitting = true
      try {
        const res = await assignClientsToSalesman(this.salesman.userId, this.selectedRelationIds)
        if (res && res.code === 200) {
          ElMessage.success('分配成功')
          this.$emit('success')
          this.mode = 'current'
          this.selectedRelationIds = []
          await this.loadClientList()
        } else {
          ElMessage.error(res?.msg || '分配失败')
        }
      } catch (e) {
        console.error('分配客户失败', e)
        ElMessage.error(e.message || '分配失败')
      } finally {
        this.assignSubmitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.assign-dialog-body {
  .mode-cards {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
  }
  .mode-card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    background: var(--el-fill-color-blank);
    border: 2px solid var(--el-border-color-lighter);
    border-radius: 10px;
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  }
  .mode-card:hover {
    border-color: var(--el-border-color);
    background: var(--el-fill-color-light);
  }
  .mode-card.is-active:not(.mode-card--assign) {
    border-color: var(--el-color-warning);
    background: var(--el-color-warning-light-9);
    box-shadow: 0 0 0 1px var(--el-color-warning-light-5);
  }
  .mode-card--assign.is-active {
    border-color: var(--el-color-primary);
    background: var(--el-color-primary-light-9);
    box-shadow: 0 0 0 1px var(--el-color-primary-light-5);
  }
  .mode-card__icon {
    flex-shrink: 0;
    width: 52px;
    height: 52px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mode-card__icon--list {
    background: var(--el-fill-color);
    color: var(--el-text-color-regular);
  }
  .mode-card.is-active:not(.mode-card--assign) .mode-card__icon--list {
    background: var(--el-color-warning-light-7);
    color: var(--el-color-warning);
  }
  .mode-card__icon--assign {
    background: var(--el-color-primary-light-8);
    color: var(--el-color-primary);
  }
  .mode-card--assign.is-active .mode-card__icon--assign {
    background: var(--el-color-primary-light-5);
    color: var(--el-color-primary);
  }
  .mode-card__text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }
  .mode-card__title {
    font-size: 15px;
    font-weight: 600;
    color: var(--el-text-color-primary);
  }
  .mode-card__desc {
    font-size: 12px;
    color: var(--el-text-color-secondary);
    line-height: 1.4;
  }

  .section {
    margin-bottom: 20px;

    .section-label {
      margin-bottom: 12px;
      font-size: 14px;
      font-weight: 500;
      color: #191919;
    }
  }

  .user-type-segment-wrap {
    padding: 0;
  }

  .user-type-segment {
    display: inline-flex;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;

    .segment-item {
      min-width: 104px;
      height: 36px;
      padding: 0 20px;
      border: none;
      background: #fff;
      color: #0d62f3;
      font-size: 14px;
      font-weight: 500;
      line-height: 36px;
      cursor: pointer;
      transition: background-color 0.2s, color 0.2s;

      &:not(:last-child) {
        border-right: 1px solid #dcdfe6;
      }

      &.active {
        background: #0d62f3;
        color: #fff;
      }

      &:hover:not(.active) {
        background: #f0f6ff;
      }
    }
  }

  .table-wrap {
    min-height: 320px;
  }

  .assign-table {
    border-radius: 8px;
    border: 1px solid #ebeef5;
    overflow: hidden;

    :deep(th.el-table__cell) {
      background-color: #f5f7fa !important;
      color: #333;
      font-weight: 600;
      padding: 12px 0;
    }

    :deep(td.el-table__cell) {
      padding: 12px 0;
    }

    .el-button {
      border-radius: 4px;
    }
  }

  .pagination-section {
    padding-top: 20px;
    padding-bottom: 4px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

@media (max-width: 768px) {
  .assign-dialog-body {
    .mode-cards {
      flex-direction: column;
      gap: 12px;
      margin-bottom: 16px;
    }

    .mode-card {
      padding: 14px 16px;
      gap: 12px;
    }

    .mode-card__icon {
      width: 44px;
      height: 44px;
    }

    .mode-card__title {
      font-size: 14px;
    }

    .mode-card__desc {
      font-size: 12px;
    }

    .section {
      margin-bottom: 16px;
    }

    .user-type-segment-wrap {
      width: 100%;
    }

    .user-type-segment {
      display: flex;
      width: 100%;
      max-width: 100%;
      flex-wrap: nowrap;
      box-sizing: border-box;

      .segment-item {
        flex: 1 1 0;
        width: 0;
        min-width: 0;
        padding: 0 12px;
        text-align: center;
      }
    }

    .table-wrap {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      min-height: 280px;
    }

    .assign-table {
      min-width: 720px;
    }

    .pagination-section {
      justify-content: center;

      :deep(.el-pagination) {
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 8px;
      }

      :deep(.el-pagination__sizes),
      :deep(.el-pagination__jump) {
        display: none;
      }
    }
  }

  .dialog-footer {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 10px;

    :deep(.el-button) {
      width: 100%;
      margin-left: 0 !important;
      min-width: 0;
      box-sizing: border-box;
    }
  }
}

@media (max-width: 480px) {
  .assign-dialog-body {
    .mode-card {
      flex-direction: column;
      align-items: flex-start;
    }

    .user-type-segment .segment-item {
      height: 34px;
      line-height: 34px;
      font-size: 13px;
    }

    .assign-table {
      min-width: 640px;
    }

    .pagination-section {
      :deep(.el-pagination__total) {
        display: none;
      }
    }
  }
}
</style>

<!-- el-dialog is teleported to body, so its outer shell cannot be targeted by scoped styles. -->
<style lang="scss">
.el-dialog.assign-customer-dialog {
  max-width: 1080px;
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 18px 24px 14px;
    margin-right: 0;
    border-bottom: 1px solid var(--el-border-color-lighter);
  }

  .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    color: var(--el-text-color-primary);
  }

  .el-dialog__headerbtn {
    top: 16px;
    width: 24px;
    height: 24px;
  }

  .el-dialog__body {
    padding: 24px 24px 20px;
    overflow-y: auto;
  }

  .el-dialog__footer {
    padding: 14px 24px 18px;
    border-top: 1px solid var(--el-border-color-lighter);
  }
}

@media (max-width: 768px) {
  .el-dialog.assign-customer-dialog {
    width: 100vw !important;
    max-width: 100vw;
    margin: 0 !important;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    display: flex;
    flex-direction: column;

    .el-dialog__header {
      padding: 16px 44px 16px 16px;
      flex-shrink: 0;
    }

    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 12px;
    }

    .el-dialog__body {
      flex: 1;
      min-height: 0;
      padding: 16px;
      overflow-y: auto;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
    }

    .el-dialog__footer {
      padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
      flex-shrink: 0;

      .el-button + .el-button {
        margin-left: 0;
      }
    }
  }

  .el-dialog.assign-customer-dialog .assign-table.el-table {
    max-height: 360px !important;
  }
}

@media (max-width: 480px) {
  .el-dialog.assign-customer-dialog {
    .el-dialog__header {
      padding: 14px 40px 14px 12px;
    }

    .el-dialog__body {
      padding: 12px;
    }

    .el-dialog__footer {
      padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));
    }
  }

  .el-dialog.assign-customer-dialog .assign-table.el-table {
    max-height: 300px !important;
  }
}
</style>
